import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'imagebanner',
  templateUrl: './imagebanner.component.html'
})
export class ImagebannerComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  activeRoute(routename: string): boolean {
    return this.router.url.indexOf(routename) > -1;
  }

}



// WEBPACK FOOTER //
// ./src/app/common/imagebanner/imagebanner.component.ts